import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IAcademicClass } from '../../models/academic';

export const AcademicClassActions = createActionGroup({
    source: 'AcademicClass',
    events: {
        'Load Classes': emptyProps(),
        'Load Classes Success': props<{ classes: IAcademicClass[] }>(),
        'Load Classes Failure': props<{ error: unknown }>(),
        'Select Class': props<{ id: string }>(),
    }
});
